import rivets from 'rivets'
import { openCart, closeCart } from './header-mobile'
let CartJS = require('shopify-cartjs')

rivets.formatters.money = (value) => `$${(value / 100)}.00`

rivets.formatters.json = (value) => {
  return JSON.stringify(value)
}

const SELECTORS = {
  CART: '#CartMobileWrap',
  CART_COUNT: '#CartItemCount',
  ADD_TO_CART_FORM: 'form#AddToCartForm',
  REMOVE_BUTTON: '.js-cart-mobile__btn-remove',
}

const cartData = {
  cart: window.FOOFOO.cart,
  moneyFormat: window.FOOFOO.money_format,
  moneyWithCurrencyFormat: window.FOOFOO.money_with_currency_format,
  defaultCurrency: window.FOOFOO.default_currency,
}

let $cart = $(SELECTORS.CART)
let $cartCounter = $(SELECTORS.CART_COUNT)
let $form = $(SELECTORS.ADD_TO_CART_FORM)

export default () => {

  CartJS.init(cartData.cart, {
    moneyFormat: cartData.moneyFormat,
    moneyWithCurrencyFormat: cartData.moneyWithCurrencyFormat,
  })

  rivets.bind($cart, {
    cart: CartJS.cart
  });

  $cart.on('click', SELECTORS.REMOVE_BUTTON, (event) => {
    event.preventDefault()
    let variantId = $(event.target).attr('data-variant-id')
    removeItem(Number(variantId))
  })

  $form.on('submit', (event) => {
    event.preventDefault()
    const data = $(event.currentTarget).serialize().split('id=')[1].split('&quantity=')
    const id = data[0]
    const quantity = data[1]
    addItem(id, quantity)
    console.log('added item')
  })

}

function addItem(id, quantity) {
  CartJS.addItem(id, quantity, {}, {
    'success': function(data, textStatus, jqXHR) {
      updateCartQuantity();
      setTimeout(() => openCart(), 300)
    },
    'error': function (jqXHR, textStatus, errorThrown) {
      alert('Could not add item to cart.');
    }
  });
}

function removeItem(id) {
  if (typeof id === 'undefined') {
    console.error('Argument (id) not provided.');
    return false;
  }
  if (typeof CartJS !== 'object') {
    console.error('CartJS not loaded.');
    return false;
  }
  CartJS.updateItemById(id, 0, {}, {
    'success': function() {
      updateCartQuantity();
    }
  });
}

function updateCartQuantity() {
  let count = 0
  $.getJSON('/cart.js', (data) => count = data.item_count)
    .then(() => $cartCounter.text(count))
    .catch()
}



// WEBPACK FOOTER //
// ./cart-mobile.js